import { AccommodationGuestDetails } from '@/renderer/types/accommodation';
import {
  formatGuestPreviewDate,
  formatGuestPreviewStatus,
  getGuestPreviewStatusClasses,
} from '@lib/utils';
import React from 'react';
import { GuestPreviewSection } from './GuestPreviewSection';

interface GuestPreviewRecentBookingsProps {
  details: AccommodationGuestDetails;
}

export const GuestPreviewRecentBookings: React.FC<
  GuestPreviewRecentBookingsProps
> = ({ details }) => {
  return (
    <GuestPreviewSection title="Recent Bookings">
      <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left text-xs font-semibold uppercase tracking-wide text-gray-400">
            <tr>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Room</th>
              <th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {details.recent_bookings.map((booking) => (
              <tr key={booking.id}>
                <td className="px-4 py-3 text-gray-700">
                  {formatGuestPreviewDate(booking.check_in)}
                </td>
                <td className="px-4 py-3 text-gray-700">
                  {booking.room_label || '—'}
                </td>
                <td className="px-4 py-3">
                  <span
                    className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${getGuestPreviewStatusClasses(booking.status)}`}
                  >
                    {formatGuestPreviewStatus(booking.status)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </GuestPreviewSection>
  );
};
